import { ReactNode } from 'react';
import { Button } from 'src/components';
import classes from './SsoButton.module.css';
import GoogleIcon from './GoogleIcon.svg';
import MicrosoftIcon from './MicrosoftIcon.svg';
import AppleIcon from './AppleIcon.svg';

type SsoButtonVariant = 'default' | 'destructive';

type SsoButtonProps = {
  provider: 'microsoft' | 'google' | 'apple';
  variant?: SsoButtonVariant;
  children?: ReactNode;
  type?: 'submit' | 'reset' | 'button';
  name?: string;
  value?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  fullWidth?: boolean;
};

export default function SsoButton({
  provider,
  variant = 'default',
  children,
  type,
  name,
  value,
  disabled,
  loading,
  onClick,
  fullWidth,
}: SsoButtonProps) {
  const className = variant === 'destructive' ? classes.ssoButtonDestructive : classes.ssoButton;

  const getIcon = () => {
    switch (provider) {
      case 'google':
        return GoogleIcon;
      case 'microsoft':
        return MicrosoftIcon;
      case 'apple':
        return AppleIcon;
    }
  };

  return (
    <Button
      leftSection={<img src={getIcon()} width={20} height={20} />}
      className={className}
      type={type}
      name={name}
      value={value}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      fullWidth={fullWidth}
    >
      {children}
    </Button>
  );
}
